import React, { useState, useEffect } from "react";
import RelevantAttributes from "./relevantAttributes";
import AnalysisOutput from "./analysisOutput";

const AttributeSelection = (props: any) => {
	const [attributeData, setAttributeData] = useState([]);
	const [attributeList, setAttributeList] = useState([]);

	useEffect(() => {
		if (props.attributeData?.data) {
			setAttributeData(props.attributeData);
			setAttributeList(props.attributeData.data.final_dict);
		}
	}, [props]);

	return (
		<>
			<div className="topSuppliers-container flex flex-col justify-start gap-y-[1vh] overflow-x-auto">
				{props.selectedFilters?.l4?.length > 0 ? (
					<>
						<div className="grow-1 basis-[100%]">
							<RelevantAttributes
								attributeList={attributeList}
								handleButtonClick={(item: any) => {
									props.handleButtonClick(item);
								}}
								selectedL4Filter={props?.selectedFilters?.l4[0]}
							/>
						</div>
					</>
				) : (
					<div className="msg-container h-full flex justify-center items-center italic">
						<span className="text-center text-black text-[2.5vh]">
							Please select the L4 category to see the relevant
							attributes
						</span>
					</div>
				)}
			</div>

			<div className="spendConsolidation-container flex flex-col gap-y-[2vh] overflow-x-auto">
				{props?.tableLoading ? (
					<div className="loaderCustom"></div>
				) : props?.selectedFilters?.l4?.length > 0 ? (
					<>
						<AnalysisOutput attributeData={attributeData} />
					</>
				) : (
					<div className="msg-container h-full flex justify-center items-center italic ">
						<span className="text-center text-black text-[2.5vh]">
							Please select the L4 category to see the relevant
							attributes
						</span>
					</div>
				)}
			</div>
		</>
	);
};
export default AttributeSelection;
